export const en = {
    nav: {
        home: "Home",
        about: "About",
        services: "Services",
        projects: "Projects",
        contact: "Contact",
    },
    hero: {
        title: "NOPA Engineering",
        subtitle: "PORTFOLIO",
        description: "Precise design of modern structures.\nFrom idea to reliable realization.",
        role: "ALIJA KOLAKOVIĆ, MSc Civil Eng.",
        position: "Director / Lead Designer",
        address: "Mitrovačka 66, 36300 Novi Pazar, Serbia",
        viewProjects: "View Projects",
        contactUs: "Contact Us",
    },
    about: {
        title: "About Us",
        description: "NOPA Engineering is a professional civil engineering design bureau, led by licensed civil engineer Alija Kolaković, MSc. The bureau is focused on quality, precision, and modern structural design, with experience in residential and commercial projects, as well as complex infrastructure and urban facilities.",
        mission: "Our work combines structural engineering expertise, understanding of architectural concepts, and complete technical documentation, aiming to achieve sustainable, safe, and economically viable solutions for investors and partners.",
        areasTitle: "Areas of work:",
        areas: [
            "Design of reinforced concrete structures",
            "Static calculations and detailed technical documentation",
            "Residential, commercial, and urban buildings",
            "Projects compliant with Eurocode",
            "Technical support and solution control during construction"
        ],
        experience: "Experience",
        projects: "Projects",
        clients: "Clients",
        years: "Years"
    },
    services: {
        title: "Our Services",
        description: "We provide a full range of civil engineering services, tailored to the specific requirements and challenges of each project, from design and static calculations to technical support and solution control during execution.",
        items: [
            {
                title: "1. Structural Design",
                details: "Residential, commercial, industrial, and urban buildings"
            },
            {
                title: "2. Static Calculations",
                details: "Reinforced concrete structures\nCalculations in accordance with Eurocode"
            },
            {
                title: "3. Formwork and Reinforcement Plans",
                details: "Formwork and reinforcement plans catering to market needs across Europe and North Africa, with a special emphasis on key industrial regions and local standards."
            },
            {
                title: "4. Technical Control and Support",
                details: "Collaboration as an external associate on the construction site\nControl of executed elements and advisory services during execution"
            },
            {
                title: "5. Consulting Services",
                details: "Project review\nAdvice in the early design phase\nOptimization of technical solutions"
            },
            {
                title: "6. Waste Management Plan",
                details: "Planning and documentation in accordance with construction site requirements"
            },
            {
                title: "7. Bill of Quantities and Estimates",
                details: "Preparation of BOQs and estimates for various markets: Germany, Serbia\nCalculation and billing situations for cost control"
            }
        ]
    },
    contact: {
        title: "Contact",
        getInTouch: "Get in Touch",
        description: "Ready to start your next project? Contact us for a consultation or quote. We are here to answer any questions you may have.",
        visitUs: "Visit Us",
        emailUs: "Email Us",
        callUs: "Call Us",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email Address",
        message: "Message",
        sendMessage: "Send Message",
        placeholderGeneric: "Enter...",
        placeholderMessage: "Tell us about your project...",
        success: "Message sent successfully! We will get back to you soon.",
        error: "An error occurred while sending. Please try again.",
        sending: "Sending..."
    },
    portfolio: {
        title: "Featured Projects",
        description: "A showcase of our engineering excellence and commitment to quality across various sectors.",
        loading: "Loading projects...",
        viewDetails: "View Details",
        viewAll: "View All Projects",
        overview: "Project Overview",
        structuralAnalysis: "Detailed structural analysis and design were performed to ensure the highest safety standards and architectural integrity. Our team worked closely with architects and contractors to deliver this project on time and within budget.",
        details: "Project Details",
        location: "Location",
        year: "Year",
        client: "Client",
        status: "Status"
    },
    footer: {
        rights: "All rights reserved."
    }
};
